import React from 'react';
import { Outlet } from 'react-router-dom';
import BrandLogo from '../common/BrandLogo';

export const AuthShell = () => {
  return (
    <div className="min-h-screen flex items-center justify-center bg-white dark:bg-darkbg-base p-4 sm:p-6 select-none relative overflow-hidden theme-transition">
      <div className="absolute inset-0 bg-[linear-gradient(to_right,rgba(0,0,0,0.04)_1px,transparent_1px),linear-gradient(to_bottom,rgba(0,0,0,0.04)_1px,transparent_1px)] dark:bg-[linear-gradient(to_right,rgba(255,255,255,0.04)_1px,transparent_1px),linear-gradient(to_bottom,rgba(255,255,255,0.04)_1px,transparent_1px)] bg-[size:4rem_4rem] [mask-image:radial-gradient(ellipse_60%_50%_at_50%_0%,#000_70%,transparent_100%)] pointer-events-none" />
      
      <div className="w-full max-w-[490px] flex flex-col items-center gap-5 relative z-10 animate-slide-in my-4">
        <div className="flex justify-center py-1">
          <BrandLogo fullLogo size="xl" />
        </div>

        <div className="w-full aspect-square max-w-[490px] glass-panel rounded-2xl p-7 sm:p-9 shadow-2xl relative overflow-hidden flex flex-col justify-center border border-slate-200/80 dark:border-darkbg-border">
          <div className="absolute -top-[100px] -right-[100px] h-[200px] w-[200px] bg-primary-500/10 rounded-full blur-[60px]" />
          <div className="w-full h-full flex flex-col justify-center">
            <Outlet />
          </div>
        </div>
      </div>
    </div>
  );
};

export default AuthShell;
